import { useCallback, useState } from 'react';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { useMyBookingsStore } from '../../../../domain/booking/stores/useMyBookingsStore';

export function useCancelBooking(booking: IBooking) {
	const [isCancelled, setIsCancelled] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<Error | undefined>(undefined);
	const myBookingsStore = useMyBookingsStore();

	const cancelBooking = useCallback(async () => {
		setIsLoading(true);

		await myBookingsStore
			.cancelBooking(booking)
			.then(() => setIsCancelled(true))
			.catch(setError);

		setIsLoading(false);
	}, [booking]);

	return { cancelBooking, isCancelled, isLoading, error };
}
